import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule }                             from '@angular/common';
import { FormsModule, ReactiveFormsModule }         from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './_pages/login/login.component';
import { NavbarComponent } from './_components/navbar/navbar.component';
import { SidebarComponent } from './_components/sidebar/sidebar.component';
import { ExplorePageComponent } from './_pages/explore-page/explore-page.component';
import { MySalesPageComponent } from './_pages/my-sales-page/my-sales-page.component';
import { DashboardPageComponent } from './_pages/dashboard-page/dashboard-page.component';
import { RevenueComponent } from './charts/revenue/revenue.component';
import { SellerRevenueComponent } from './charts/seller-revenue/seller-revenue.component';
import { SellerPageComponent } from './_pages/seller-page/seller-page.component';
import { SellerPageCategoriesComponent } from './charts/seller-page-categories/seller-page-categories.component';
import { ModalComponent } from './_components/modal/modal.component';
import { ComparePageComponent } from './_pages/compare-page/compare-page.component';
import { StoreComparationComponent } from './charts/store-comparation/store-comparation.component';
import { SellerSearchPageComponent } from './_pages/seller-search-page/seller-search-page.component';
import { SellerRankingPageComponent } from './_pages/seller-ranking-page/seller-ranking-page.component';
import { ItemsSoldComponent } from './charts/dashboard/items-sold/items-sold.component';
import { ItemsAvailableComponent } from './charts/dashboard/items-available/items-available.component';
import { ItemsPricesUyuComponent } from './charts/dashboard/items-prices-uyu/items-prices-uyu.component';
import { ItemsPricesUsdComponent } from './charts/dashboard/items-prices-usd/items-prices-usd.component';
import { ListingsSearchPageComponent } from './_pages/listings-search-page/listings-search-page.component';
import { FaqPageComponent } from './_pages/faq-page/faq-page.component';
import { RecommendationsPageComponent } from './_pages/recommendations-page/recommendations-page.component';
import { SellersRevenueComponent } from './charts/dashboard/sellers-revenue/sellers-revenue.component';

@NgModule({
  declarations: [
    AppComponent,    
    LoginComponent,
    NavbarComponent,
    SidebarComponent,
    ExplorePageComponent,
    MySalesPageComponent,
    DashboardPageComponent,
    RevenueComponent,
    SellerRevenueComponent,
    SellerPageComponent,
    SellerPageCategoriesComponent,
    ModalComponent,
    ComparePageComponent,
    StoreComparationComponent,
    SellerSearchPageComponent,
    SellerRankingPageComponent,
    ItemsSoldComponent,
    ItemsAvailableComponent,
    ItemsPricesUyuComponent,
    ItemsPricesUsdComponent,
    ListingsSearchPageComponent,
    FaqPageComponent,
    RecommendationsPageComponent,
    SellersRevenueComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,    
  ], exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
